import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { ReactComponent as Calendar } from 'icons/calendar-today-blue.svg';
import { DayPicker } from 'react-day-picker';
import { format } from 'date-fns';

const css = `
  .my-selected:not([disabled]) { 
    font-weight: bold; 
    background-color: black;
    color: white;
  }
  .my-selected:hover([disabled]) { 
    color: currentColor;
    border: 1px solid #000;
  }
`;

export const DateFilter = ({ className, style, placeholder, selectedDate }) => {
  const dropdownRef = useRef(null);
  const [isShowDropdown, setIsShowDropdown] = useState(false);
  const [days, setDays] = useState({ from: undefined, to: undefined });
  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');

  useEffect(() => {
    // Add a click event listener to the document to handle clicks outside the dropdown.
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsShowDropdown(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      // Remove the event listener when the component unmounts.
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsShowDropdown(!isShowDropdown);
  };

  const chooseDate = (date) => {
    setDays(date);
    setCustomStartDate(date.from);
    setCustomEndDate(date.to);

    if (date.from && date.to) {
      selectedDate(date.from, date.to);
    }
  };

  return (
    <div className={clsx('date-filter', className)} style={style} ref={dropdownRef}>
      <div className="date-filter__field" onClick={toggleDropdown}>
        <Calendar />
        <div className="date-filter__field__input">
          {customStartDate && customEndDate
            ? `${format(new Date(customStartDate), 'yyyy/MM/dd')} - ${format(new Date(customEndDate), 'yyyy/MM/dd')}`
            : placeholder}
        </div>
      </div>

      {isShowDropdown && (
        <div className="date-filter__dropdown">
          <>
            <style>{css}</style>
            <DayPicker
              selected={days}
              numberOfMonths={2}
              onSelect={chooseDate}
              mode="range"
              className={'date-filter__dropdown__date'}
              modifiersClassNames={{
                selected: 'my-selected',
                today: 'my-today',
              }}
              styles={{
                caption_label: { fontSize: '16px' },
                caption: { marginBottom: '33px' },
                head: { color: '#8E8C9A' },
                head_cell: { textTransform: 'capitalize' },
              }}
            />
          </>
        </div>
      )}
    </div>
  );
};
